import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/organizations',
  	  method: 'get',
        params
  	})
  }
  
  export function inventory(params) {
    return request({
      url: '/organizations/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/organizations/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/organizations',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/organizations/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/organizations/${id}`,
      method: 'delete',
    })
  }
